"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supplyStates = void 0;
var date_fns_1 = require("date-fns");
var utils_1 = require("../../utils");
var isOnboarding_1 = require("../../utils/isOnboarding");
var isActiveSupplyMeter = function (supplyEndDate, meterStatus) {
    return supplyEndDate
        ? (0, date_fns_1.isAfter)(supplyEndDate, (0, date_fns_1.endOfToday)())
        : true && meterStatus === 'active';
};
var isMultiRate = function (meter) { return meter.registers.length > 1; };
var hasSubmittedOmrs = function (readings) {
    return readings.filter(function (reading) { return reading.readingType === 'OpeningReadingActual'; })
        .length > 0;
};
var supplyStates = function (meter, supplyPoint, readings) {
    var _a;
    var isSmart = (0, utils_1.isSmartSupply)((_a = meter.rawMeterType) !== null && _a !== void 0 ? _a : '');
    return {
        isActive: isActiveSupplyMeter(supplyPoint.endDate, meter.meterStatus),
        isBeforeSupplyStart: (0, date_fns_1.isBefore)((0, date_fns_1.startOfToday)(), supplyPoint.startDate),
        showSimplifiedLabels: !isMultiRate(meter),
        //Smart
        isSmart: isSmart,
        //Onboarding
        isOnboarding: (0, isOnboarding_1.isOnboarding)(supplyPoint.startDate, meter.msn),
        hasSubmittedOmrs: hasSubmittedOmrs(readings),
        //Regulatory information
        isNonComms: (0, utils_1.isNonCommsMeter)(isSmart, readings),
    };
};
exports.supplyStates = supplyStates;
